import React from 'react';
import { APP_CONTAINER_ROUTES, CREDIT_REQUEST_INVOICE_ROUTES } from './routes';
import {
  AppContainerStackParams,
  CreditRequestInvoiceStackParams,
} from './types';
import { createStackNavigator } from '@react-navigation/stack';
import { CreditRequestInvoiceDetailsScreen } from '@/screens/credit-request/credit-request-invoice-details-screen';
import { CreditRequestInvoiceItemsScreen } from '@/screens/credit-request/credit-request-invoice-items-screen';
import { CreditRequestInvoiceStoreProvider } from '@/stores/credit-request-invoice-store';
import { RouteProp, useRoute } from '@react-navigation/native';
import { useDefaultStackScreenOptions } from '@/hooks/use-default-stack-screen-options';

type RouteProps = RouteProp<
  AppContainerStackParams,
  typeof APP_CONTAINER_ROUTES.CreditRequestInvoiceItems
>;

const Stack = createStackNavigator<CreditRequestInvoiceStackParams>();

export const CreditRequestInvoiceStack: React.FC = () => {
  const options = useDefaultStackScreenOptions();
  const route = useRoute<RouteProps>();
  const { orderInvoiceUUID, title } = route.params;
  return (
    <CreditRequestInvoiceStoreProvider>
      <Stack.Navigator
        initialRouteName={
          CREDIT_REQUEST_INVOICE_ROUTES.CreditRequestInvoiceItems
        }
        screenOptions={options}
      >
        <Stack.Screen
          component={CreditRequestInvoiceItemsScreen}
          initialParams={{ orderInvoiceUUID, title }}
          name={CREDIT_REQUEST_INVOICE_ROUTES.CreditRequestInvoiceItems}
        />
        <Stack.Screen
          component={CreditRequestInvoiceDetailsScreen}
          name={CREDIT_REQUEST_INVOICE_ROUTES.CreditRequestInvoiceDetails}
        />
      </Stack.Navigator>
    </CreditRequestInvoiceStoreProvider>
  );
};
